export default "__VITE_ASSET__6484d62e__"